import { useQuery } from 'react-query';
import { listColors } from './Colors.service';
import { queryClient } from '@/Root';
import notificationError from '@/utils/functions/notificationError';

export function useColors(enabled = true) {
  const cache = queryClient.getQueryData(['colors']);

  return useQuery(['colors'], listColors, {
    enabled: enabled && !cache,
    onError(error) {
      notificationError(error);
    },
  });
}
